/**
 * What a property photo upload may be.
 *
 * 13 Darebin Road, 1 Oct 2026: 16 .webp photos uploaded through the CRM
 * looked perfect everywhere in-house while the live realestate.com.au
 * listing showed "Sorry, no image :(" in every slot - REA's media pipeline
 * only ingests jpg/png/gif. The backend now converts WebP to JPEG on the
 * way in and refuses everything else it cannot convert (HEIC, AVIF, TIFF,
 * ...); this is the matching front-end gate so the agent hears about a bad
 * file at pick time, with the file named, instead of a 400 after a long
 * upload.
 *
 * Video formats are included because the Add Property page feeds videos
 * through the same "images" field.
 */

export const SUPPORTED_UPLOAD_ACCEPT =
  ".jpg,.jpeg,.png,.gif,.webp,.mp4,.mov,.webm,.ogg";

const SUPPORTED_RE = /\.(jpe?g|png|gif|webp|mp4|mov|webm|ogg)$/i;

/** Split a FileList/array into supported files and rejected ones. */
export function splitSupportedUploads(files) {
  const ok = [];
  const rejected = [];
  Array.from(files || []).forEach((f) => {
    (SUPPORTED_RE.test(f?.name || "") ? ok : rejected).push(f);
  });
  return { ok, rejected };
}

/** One wording for the rejection toast, mirroring the backend's 400. */
export function rejectedUploadsMessage(rejected) {
  const names = rejected.slice(0, 3).map((f) => `"${f.name}"`).join(", ");
  const extra = rejected.length > 3 ? ` (and ${rejected.length - 3} more)` : "";
  return `${names}${extra}: file type not supported by realestate.com.au. Please upload JPG, PNG or GIF photos.`;
}
